import type { ReactNode } from 'react';
import { Badge } from '@/shared/ui/badge';
import { Checkbox } from '@/shared/ui/checkbox';

/**
 * The accept control of one proposed row.
 *
 * The checkbox says whether this row is saved, and the `Unsure` badge is shown
 * whenever the proposal said it was unsure: a marker nobody can see is not a
 * marker.
 */
export type DraftAcceptProps = {
  readonly label: string;
  readonly accepted: boolean;
  readonly uncertain: boolean;
  readonly onToggle: () => void;
};

export function DraftAccept({
  label,
  accepted,
  uncertain,
  onToggle,
}: DraftAcceptProps): ReactNode {
  return (
    <div className="flex flex-wrap items-center justify-between gap-2">
      <Checkbox label={label} checked={accepted} onChange={onToggle} />
      {uncertain ? <Badge tone="caution">Unsure</Badge> : null}
    </div>
  );
}
